const q = (market) => `?market=${encodeURIComponent(market)}`;
export class RiderCouponsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async list(market, categoryCode) {
        return this.client.request({ method: 'GET', path: `/v1/rider/coupons${q(market)}${categoryCode !== undefined ? `&categoryCode=${encodeURIComponent(categoryCode)}` : ''}`, auth: true });
    }
    referral(market) {
        return this.client.request({ method: 'GET', path: `/v1/rider/referral${q(market)}`, auth: true });
    }
    referralCode(market) {
        return this.client.request({ method: 'POST', path: `/v1/rider/referral/code${q(market)}`, body: {}, auth: true });
    }
    applyReferral(market, code) {
        return this.client.request({ method: 'POST', path: `/v1/rider/referral/apply${q(market)}`, body: { code }, auth: true });
    }
    /** D723 "Convide motoristas": `GET /v1/rider/driver-referral` - the open campaigns per category, the rider's code and his invited drivers' progress. */
    driverInvite(market) {
        return this.client.request({ method: 'GET', path: `/v1/rider/driver-referral${q(market)}`, auth: true });
    }
    /** D723: `POST /v1/rider/driver-referral/code` - the rider's invitation code (the same one every time). */
    driverInviteCode(market) {
        return this.client.request({ method: 'POST', path: `/v1/rider/driver-referral/code${q(market)}`, body: {}, auth: true });
    }
}
/** D723: Admin › Indicações - the driver invitation campaigns under four eyes (`campaign:manage` / `campaign:view` at the market). */
export class DriverReferralAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    list(market) {
        return this.client.request({ method: 'GET', path: `/v1/driver-referral-campaigns${q(market)}`, auth: true });
    }
    propose(input) {
        return this.client.request({ method: 'POST', path: '/v1/driver-referral-campaigns', body: input, auth: true });
    }
    /** A DIFFERENT operator approves or refuses a proposal. */
    decide(market, campaignId, approve, note) {
        return this.client.request({ method: 'POST', path: `/v1/driver-referral-campaigns/${encodeURIComponent(campaignId)}/decision${q(market)}`, body: { approve, ...(note !== undefined ? { note } : {}) }, auth: true });
    }
    proposeChange(market, campaignId, change) {
        return this.client.request({ method: 'POST', path: `/v1/driver-referral-campaigns/${encodeURIComponent(campaignId)}/changes${q(market)}`, body: change, auth: true });
    }
    decideChange(market, campaignId, approve) {
        return this.client.request({ method: 'POST', path: `/v1/driver-referral-campaigns/${encodeURIComponent(campaignId)}/changes/decision${q(market)}`, body: { approve }, auth: true });
    }
    end(market, campaignId) {
        return this.client.request({ method: 'POST', path: `/v1/driver-referral-campaigns/${encodeURIComponent(campaignId)}/end${q(market)}`, body: {}, auth: true });
    }
    referrals(market, filter = {}) {
        const params = new URLSearchParams({ market });
        if (filter.campaignId !== undefined)
            params.set('campaignId', filter.campaignId);
        if (filter.state !== undefined)
            params.set('state', filter.state);
        return this.client.request({ method: 'GET', path: `/v1/driver-referrals?${params.toString()}`, auth: true });
    }
}
export class CouponAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    create(input) {
        return this.client.request({ method: 'POST', path: '/v1/coupons', body: input, auth: true });
    }
    list(market, filter = {}) {
        const params = new URLSearchParams({ market });
        if (filter.active !== undefined)
            params.set('active', filter.active ? '1' : '0');
        if (filter.campaign !== undefined)
            params.set('campaign', filter.campaign);
        if (filter.source !== undefined)
            params.set('source', filter.source);
        if (filter.limit !== undefined)
            params.set('limit', String(filter.limit));
        if (filter.next !== undefined) {
            params.set('beforeCreatedAt', filter.next.beforeCreatedAt);
            params.set('beforeId', filter.next.beforeId);
        }
        return this.client.request({ method: 'GET', path: `/v1/coupons?${params.toString()}`, auth: true });
    }
    get(market, couponId) {
        return this.client.request({ method: 'GET', path: `/v1/coupons/${encodeURIComponent(couponId)}${q(market)}`, auth: true });
    }
    adjust(market, couponId, patch) {
        return this.client.request({ method: 'PATCH', path: `/v1/coupons/${encodeURIComponent(couponId)}${q(market)}`, body: patch, auth: true });
    }
    budget(market) {
        return this.client.request({ method: 'GET', path: `/v1/coupon-budget${q(market)}`, auth: true });
    }
    createCampaign(input) {
        return this.client.request({ method: 'POST', path: '/v1/referral-campaigns', body: input, auth: true });
    }
    campaigns(market) {
        return this.client.request({ method: 'GET', path: `/v1/referral-campaigns${q(market)}`, auth: true });
    }
    adjustCampaign(market, campaignId, patch) {
        return this.client.request({ method: 'PATCH', path: `/v1/referral-campaigns/${encodeURIComponent(campaignId)}${q(market)}`, body: patch, auth: true });
    }
    /** H-034: who invited whom, the state and the rides done. */
    history(market, filter = {}) {
        const params = new URLSearchParams({ market });
        if (filter.campaignId !== undefined)
            params.set('campaignId', filter.campaignId);
        if (filter.state !== undefined)
            params.set('state', filter.state);
        if (filter.limit !== undefined)
            params.set('limit', String(filter.limit));
        return this.client.request({ method: 'GET', path: `/v1/referrals?${params.toString()}`, auth: true });
    }
    codes(market, campaignId) {
        return this.client.request({ method: 'GET', path: `/v1/referral-codes${q(market)}${campaignId !== undefined ? `&campaignId=${encodeURIComponent(campaignId)}` : ''}`, auth: true });
    }
}
//# sourceMappingURL=coupons.js.map